module.exports = __webpack_public_path__ + "img/stability2.657b492d.png";